import { LocalizedEnum } from '@packages/components/localized-enum/localized-enum';
import { NoDataEnDash } from '@packages/components/no-data-en-dash/no-data-en-dash';
import { List, ListItem } from '@packages/fenrir/components';
import type { GridRenderCellParams } from '@packages/fenrir/components/datagrid';

// TODO - Extend the support for longer lists by adding View More button

type EnumShortListCellProps = GridRenderCellParams & {
  translationKey: string;
};

/**
 * For enum list containing 5 items or less.
 */
export const EnumShortListCell = (params: EnumShortListCellProps) => {
  return params.value ? (
    <List sx={{ width: '100%' }}>
      {params.value.map((item: string) => (
        <ListItem sx={{ p: 0.25 }} key={item}>
          <LocalizedEnum translationKey={params.translationKey} value={item} />
        </ListItem>
      ))}
    </List>
  ) : (
    <NoDataEnDash />
  );
};
